module.exports = __webpack_public_path__ + "img/KH.55aa18a8.png";